import React from 'react';

const FormSelect = ({register,error,label,id,...inputProps}) => {
    return <>
    	<div className="form-group">
            <label htmlFor={id}>{label}</label>
            <select 
                ref={register}
                id={id}
                className={`form-control ${error ? "is-invalid" : ""}`}
                {...inputProps}
            >
                <option value="">--- SELECCIONE ---</option>
                <option value="no_contesto">Sin respuesta</option>
                <option value="femenino">Femenino</option>
                <option value="masculino">Masculino</option>
			</select>
            {error && <div className="invalid-feedback">{error.message}</div>}
        </div>
    </>
};
export default FormSelect;